var _g, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7525_28917)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#FFCC1D"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 57,
    stroke: "#F1C220",
    strokeWidth: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7525_28917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5003 41.5C80.7601 41.5 81.9683 42.0004 82.8591 42.8912C83.7499 43.782 84.2503 44.9902 84.2503 46.25V74.75C84.2503 76.0098 83.7499 77.218 82.8591 78.1088C81.9683 78.9996 80.7601 79.5 79.5003 79.5H41.5003C40.2405 79.5 39.0323 78.9996 38.1415 78.1088C37.2507 77.218 36.7503 76.0098 36.7503 74.75V72.375H41.5003V74.75H79.5003V49.6296L63.0297 66.1003C62.3616 66.7681 61.4556 67.1433 60.511 67.1433C59.5663 67.1433 58.6604 66.7681 57.9923 66.1003L41.5003 49.6082V51H36.7503V46.25C36.7503 44.9902 37.2507 43.782 38.1415 42.8912C39.0323 42.0004 40.2405 41.5 41.5003 41.5H79.5003ZM46.2503 62.875C46.8556 62.8757 47.4379 63.1075 47.878 63.523C48.3182 63.9386 48.5831 64.5065 48.6186 65.1108C48.6541 65.7151 48.4574 66.3102 48.0689 66.7744C47.6804 67.2386 47.1293 67.5369 46.5282 67.6084L46.2503 67.625H34.3753C33.77 67.6243 33.1877 67.3925 32.7475 66.977C32.3074 66.5614 32.0425 65.9935 32.007 65.3892C31.9715 64.7849 32.1682 64.1898 32.5567 63.7256C32.9452 63.2614 33.4963 62.9631 34.0974 62.8916L34.3753 62.875H46.2503ZM43.8753 55.75C44.5052 55.75 45.1093 56.0002 45.5547 56.4456C46.0001 56.891 46.2503 57.4951 46.2503 58.125C46.2503 58.7549 46.0001 59.359 45.5547 59.8044C45.1093 60.2498 44.5052 60.5 43.8753 60.5H36.7503C36.1204 60.5 35.5163 60.2498 35.0709 59.8044C34.6255 59.359 34.3753 58.7549 34.3753 58.125C34.3753 57.4951 34.6255 56.891 35.0709 56.4456C35.5163 56.0002 36.1204 55.75 36.7503 55.75H43.8753Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7525_28917",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7525_28917"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7525_28917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white",
    transform: "translate(32 32)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email-verified.f6ab8e229cda2d55e0ecc5596c4954ea.svg";
export { ForwardRef as ReactComponent };